import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_CorrectAfterWrong extends QuestionPassState {
    id = QuestionPassStateId.CorrectAfterWrong;
    name = '1x Richtig nach Falschantwort';
    color = 'success';
    orderInProgressbar = 4;
    isDefaultFiltered = true;
}
